<div class="demo-modal-panel">
    <button class="sidebar-demo-control">
        <span>Gallery</span>
    </button>
</div>

<div class="example-demo-modal">
    <div class="inner">
        <ul>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/01.jpg" alt="image">
                    <a href="assets/img/gallery/01.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/02.png" alt="image">
                    <a href="assets/img/gallery/02.png" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/03.jpg" alt="image">
                    <a href="assets/img/gallery/03.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/04.jpg" alt="image">
                    <a href="assets/img/gallery/04.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/05.jpg" alt="image">
                    <a href="assets/img/gallery/05.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/06.jpg" alt="image">
                    <a href="assets/img/gallery/06.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/07.jpg" alt="image">
                    <a href="assets/img/gallery/07.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/08.jpg" alt="image">
                    <a href="assets/img/gallery/08.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/09.jpg" alt="image">
                    <a href="assets/img/gallery/09.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/10.jpg" alt="image">
                    <a href="assets/img/gallery/10.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/11.jpg" alt="image">
                    <a href="assets/img/gallery/11.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/12.jpg" alt="image">
                    <a href="assets/img/gallery/12.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/13.jpg" alt="image">
                    <a href="assets/img/gallery/13.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/14.jpg" alt="image">
                    <a href="assets/img/gallery/14.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/15.jpg" alt="image">
                    <a href="assets/img/gallery/15.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/16.jpg" alt="image">
                    <a href="assets/img/gallery/16.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/17.jpg" alt="image">
                    <a href="assets/img/gallery/17.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/18.jpg" alt="image">
                    <a href="assets/img/gallery/18.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/19.jpg" alt="image">
                    <a href="assets/img/gallery/19.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/20.jpg" alt="image">
                    <a href="assets/img/gallery/20.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
            <li>
                <div class="works-details-image">
                    <img src="assets/img/gallery/21.jpg" alt="image">
                    <a href="assets/img/gallery/21.jpg" class="popup-btn"><i class="ri-add-line"></i></a>
                </div>
            </li>
        </ul>
    </div>
    <div class="header-title">
        <button class="example-demo-modal-control">
            <i class="ri-close-line"></i>
        </button>
        <div class="title">View Gallery</div>
    </div>
</div>